import Config from "src/Constants/Config";
import CustomCenterContent from "src/Pages/CustomCenterContent";
import IntroMEF from "src/Component/IntroMEF";

const PageId = 2;

const DATA = () => {
  return {
    showHeader: true,
    bgVideo: {
      video: `${Config.BASE_URL}/videos/mef.mp4`,
      poster: `${Config.BASE_URL}/images/bg_2.jpg`,
    },
    children: (
      <CustomCenterContent pageId={PageId} customBackPageId={0} showLogos={true}>
        <IntroMEF />
      </CustomCenterContent>
    ),
  };
};

export default DATA;
